import { render, staticRenderFns } from "./VRMarketEnvironment.vue?vue&type=template&id=7566d13a"
import script from "./VRMarketEnvironment.vue?vue&type=script&lang=js"
export * from "./VRMarketEnvironment.vue?vue&type=script&lang=js"
import style0 from "./VRMarketEnvironment.vue?vue&type=style&index=0&id=7566d13a&prod&scope=true&lang=css"
import style1 from "./VRMarketEnvironment.vue?vue&type=style&index=1&id=7566d13a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports